import Cookies from "js-cookie";
import axios from "./axios";

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    Cookies.set("__cribsfinder_token", accessToken, {
      domain: ".cribsfinder.com",
      secure: true,
      path: "/",
      sameSite: "Lax",
      expires: 365,
    });
    Cookies.set("__cribsfinder_type", "guest", {
      domain: ".cribsfinder.com",
      secure: true,
      path: "/",
      sameSite: "Lax",
      expires: 365,
    });
    setHeader();
  } else {
    localStorage.removeItem("accessToken");
    Cookies.remove("__cribsfinder_token", {
      domain: ".cribsfinder.com",
      secure: true,
      path: "/",
      sameSite: "Lax",
      expires: 365,
    });
    Cookies.remove("__cribsfinder_type", {
      domain: ".cribsfinder.com",
      secure: true,
      path: "/",
      sameSite: "Lax",
      expires: 365,
    });
  }
};
const setHeader = () => {
  const accessToken = window.localStorage.getItem("accessToken")
    ? window.localStorage.getItem("accessToken")
    : "";
  axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
};

const setHideWallet = (isHidden) => {
  if (isHidden) {
    localStorage.setItem("hideWallet", "true");
  } else {
    localStorage.removeItem("hideWallet");
  }
};
const getHideWallet = () => window.localStorage.getItem("hideWallet") || "";

export { setSession, setHeader, setHideWallet, getHideWallet };
